"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.ReadMode = void 0;
var _react = _interopRequireDefault(require("react"));
var _CountryFlag = require("../../Components/CountrySelector/CountryFlag");
var _jsxRuntime = require("react/jsx-runtime");
/* eslint-disable react/jsx-props-no-spreading */

/**
 * Primary UI component for form fields in read mode
 */
const ReadMode = ({
  title,
  details,
  hasCountryFlag,
  countryCode,
  ...props
}) => {
  const cssComponentClass = 'ccl__read-mode';
  const cssTextClass = 'ccl__text';
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("dl", {
    className: cssComponentClass,
    ...props,
    children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("dt", {
      className: `${cssTextClass}__title ${cssTextClass} ${cssTextClass}--body-text-bold `,
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("dd", {
      className: `${cssComponentClass}__details ${cssTextClass} ${cssTextClass}--body-text ${hasCountryFlag ? `${cssComponentClass}__details--has-flag` : ''}`,
      children: [hasCountryFlag && /*#__PURE__*/(0, _jsxRuntime.jsx)(_CountryFlag.CountryFlag, {
        countryCode: countryCode
      }), details.map(detail => {
        // check the content of the details array
        const Tag = typeof detail === 'string' ? 'p' : 'div';
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(Tag, {
          "data-nw-detail": true,
          children: detail
        }, detail);
      })]
    })]
  });
};
exports.ReadMode = ReadMode;
ReadMode.defaultProps = {
  hasCountryFlag: false,
  countryCode: ''
};